import styled from 'styled-components';

const AppHeader = styled.header`
  text-align: center;
  padding-top: 3rem;
  padding-bottom: 2rem;
  margin-bottom: 2rem;
  .Container {
    position: relative;
  }
  h1,
  h2 {
    margin: 0;
  }
  .lead {
    font-size: 1.9rem;
    font-weight: 300;
    max-width: 56ch;
    margin: 0 auto;
  }
  a {
    color: var(--color-ui-blue);
  }
`;

export { AppHeader };
